import services from '@/services/ascentiaServiceIndex'
import { AIRLINE_MANAGEMENT_CONSTS as AOC } from '../consts'
import { AIRLINE_TEXT_FIELD } from '@/utilities/appConsts'
import moment from 'moment'

const state = {
  allAirlines: [],
  airline: {},
  newAirlineToast: false,
  editAirlineToast: false,
  allAgreements: [],
  newAgreementToast: false,
  agreementTypes: [],
  airlinesByTier: [],
}

const getters = {}

const mutations = {
  [AOC.UPDATE_ALL_AIRLINES]: (state, data) => (state.allAirlines = data),
  [AOC.UPDATE_AIRLINE]: (state, data) => (state.airline = data),
  [AOC.UPDATE_FILTERED_AIRLINES]: (state, data) =>
    (state.airlinesByTier = data),
  [AOC.EDIT_AIRLINE_TOAST]: (state, data) => (state.editAirlineToast = data),
  [AOC.NEW_AIRLINE_TOAST]: (state, data) => (state.newAirlineToast = data),
  [AOC.UPDATE_ALL_AGREEMENTS]: (state, data) => (state.allAgreements = data),
  [AOC.UPDATE_AGREEMENT_TOAST]: (state, data) =>
    (state.newAgreementToast = data),
  [AOC.UPDATE_AGREEMENT_TYPES]: (state, data) => (state.agreementTypes = data),
}

const actions = {
  async [AOC.GET_ALL_AIRLINES]({ commit }, args = { refresh: false }) {
    try {
      const response = await services.airlineManagement.getData(
        'allAirlines',
        null,
        args.refresh,
      )
      const data = response.data
      commit(AOC.UPDATE_ALL_AIRLINES, data)
    } catch (error) {
      console.log(`${[AOC.GET_ALL_AIRLINES]}: error ${error}`)
    }
  },
  async [AOC.FIND_AIRLINES]({ commit }, airlineTiers) {
    try {
      const response = await services.airlineManagement.getData(
        'airlinesByTier',
        airlineTiers,
      )
      const data = response.data
        .filter(item => item.icaoCode !== null)
        .map(item => {
          return {
            airlineId: item.id,
            airlineName: item.name,
            icaoCode: item.icaoCode,
            text: item[AIRLINE_TEXT_FIELD],
            value: item.id,
            search: `${item[AIRLINE_TEXT_FIELD]}${item.icaoCode}`,
            runLimit: item.runLimit,
          }
        })
      commit(AOC.UPDATE_FILTERED_AIRLINES, data)
    } catch (error) {
      console.log(`${[AOC.FIND_AIRLINES]}: error ${error}`)
    }
  },
  async [AOC.GET_AIRLINE]({ commit }, airlineId) {
    try {
      const response = await services.airlineManagement.getData(
        'airline',
        airlineId,
        true,
      )
      const data = response.data
      commit(AOC.UPDATE_AIRLINE, data)
    } catch (error) {
      console.log(`${[AOC.GET_AIRLINE]}: error ${error}`)
    }
  },
  async [AOC.SAVE_UPDATED_AIRLINE]({ commit, dispatch }, airline) {
    try {
      commit(AOC.EDIT_AIRLINE_TOAST, false)
      const response = await services.airlineManagement.saveData(
        'updateAirline',
        airline,
      )
      if (response.status === 200 && response.data === 1) {
        commit(AOC.EDIT_AIRLINE_TOAST, true)
        dispatch(AOC.GET_ALL_AIRLINES, { refresh: true })
      } else {
        commit(AOC.EDIT_AIRLINE_TOAST, false)
      }
    } catch (error) {
      console.log(`${[AOC.SAVE_UPDATED_AIRLINE]}: error ${error}`)
    }
  },
  async [AOC.SAVE_NEW_AIRLINE]({ commit, dispatch }, airline) {
    try {
      commit(AOC.NEW_AIRLINE_TOAST, false)
      const response = await services.airlineManagement.saveData(
        'newAirline',
        airline,
      )
      if (response.status === 201) {
        commit(AOC.NEW_AIRLINE_TOAST, true)
        await dispatch(AOC.GET_ALL_AIRLINES, { refresh: true })
      } else {
        commit(AOC.NEW_AIRLINE_TOAST, false)
      }
    } catch (error) {
      console.log(`${[AOC.SAVE_NEW_AIRLINE]}: error ${error}`)
    }
  },
  async [AOC.GET_ALL_AGREEMENTS]({ commit }) {
    try {
      const response = await services.airlineManagement.getData(
        'allAgreements',
        null,
        true,
      )
      if (response) {
        const data = response.data.map(item => {
          return {
            id: item.id,
            airlineId: item.airline.id,
            airlineName: item.airline.name,
            masterModelId: item.masterModel.id,
            masterModelName: item.masterModel.name,
            fromDate: item.fromDate,
            toDate: item.toDate,
            agreementTypeId: item.airlineAgreementType.id,
            agreementTypeName: item.airlineAgreementType.name,
            isExpired: !moment().isBetween(item.fromDate, item.toDate)
              ? true
              : false,
            isBillable: item.isBillable,
          }
        })
        commit(AOC.UPDATE_ALL_AGREEMENTS, data)
      }
    } catch (error) {
      console.log(`${[AOC.GET_ALL_AGREEMENTS]}: error ${error}`)
    }
  },
  async [AOC.SAVE_NEW_AGREEMENT]({ commit, dispatch }, agreement) {
    try {
      commit(AOC.UPDATE_AGREEMENT_TOAST, false)
      for (let x = 0; x < agreement.masterModelId.length; x++) {
        const data = {
          ...agreement,
          masterModelId: agreement.masterModelId[x],
        }
        await services.airlineManagement.saveData('newAgreement', data)
      }
      commit(AOC.UPDATE_AGREEMENT_TOAST, true)
      dispatch(AOC.GET_ALL_AGREEMENTS, { refresh: true })
    } catch (error) {
      commit(AOC.UPDATE_AGREEMENT_TOAST, false)
      console.log(`${[AOC.SAVE_NEW_AGREEMENT]}: error ${error}`)
    }
  },
  async [AOC.GET_AGREEMENT_TYPES]({ commit }) {
    try {
      const response = await services.airlineManagement.getData(
        'agreementTypes',
      )
      const data = response.data
      commit(AOC.UPDATE_AGREEMENT_TYPES, data)
    } catch (error) {
      commit(AOC.UPDATE_AGREEMENT_TYPES, [])
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
